var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 10.0999C16.3233 10.0999 10.1 16.3231 10.1 23.9999C10.1 31.6767 16.3233 37.8999 24 37.8999C31.6768 37.8999 37.9 31.6767 37.9 23.9999C37.9 16.3231 31.6768 10.0999 24 10.0999ZM7.90002 23.9999C7.90002 15.1081 15.1082 7.8999 24 7.8999C32.8918 7.8999 40.1 15.1081 40.1 23.9999C40.1 32.8917 32.8918 40.0999 24 40.0999C15.1082 40.0999 7.90002 32.8917 7.90002 23.9999Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7762 19.7794L23.2678 29.2477C23.2675 29.2481 23.2672 29.2484 23.2668 29.2487C22.331 30.1834 20.8469 30.1384 19.9585 29.1933L19.9529 29.1873L19.9529 29.1873L15.1929 24.0473L16.8071 22.5525L21.5631 27.6882C21.5928 27.7191 21.6203 27.726 21.6395 27.7264C21.6504 27.7266 21.6611 27.7247 21.6715 27.7206C21.6812 27.7167 21.6952 27.7091 21.7122 27.6921L21.7138 27.6905L31.2238 18.2205L32.7762 19.7794Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon_check_circle.942fa45c.svg";
export { ForwardRef as ReactComponent };